'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _nukaCarousel = require('nuka-carousel');

var _nukaCarousel2 = _interopRequireDefault(_nukaCarousel);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _config = require('../../../config');

var _config2 = _interopRequireDefault(_config);

var _S3FileUploader = require('../../../helpers/S3FileUploader');

var _S3FileUploader2 = _interopRequireDefault(_S3FileUploader);

var _helper = require('../../../helpers/helper');

var _components = require('components');

var _SliderDecorator = require('./SliderDecorator');

var _SliderDecorator2 = _interopRequireDefault(_SliderDecorator);

var _EditModal = require('./EditModal.scss');

var _EditModal2 = _interopRequireDefault(_EditModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditModal = function (_Component) {
  (0, _inherits3.default)(EditModal, _Component);

  function EditModal(props) {
    (0, _classCallCheck3.default)(this, EditModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(EditModal).call(this, props));

    _this.state = {
      item: props.item,
      progress: 0
    };

    _this._handleEdit = _this._handleEdit.bind(_this);
    _this._onDrop = _this._onDrop.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(EditModal, [{
    key: '_onDrop',
    value: function _onDrop(files) {
      var _this2 = this;

      var uploader = new _S3FileUploader2.default(files[0]);

      uploader.on('progress', function (percent) {
        _this2.setState({ progress: percent });
      });

      uploader.on('complete', function (result) {
        _this2.setState({
          progress: null
        });
        _this2._handleEdit('images', ['https://s3.amazonaws.com/outfeats/' + result.filename]);
      });

      uploader.on('error', function (status) {
        _this2.setState({ error: status, progress: null });
      });
      return _bluebird2.default.resolve().then(function () {
        return uploader.start();
      }).finally(function () {
        _this2.setState({ progress: 0 });
      });
    }
  }, {
    key: '_handleEdit',
    value: function _handleEdit(key, value) {
      var item = this.state.item;
      item[key] = value;
      this.setState({ item: item });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _onClose = this.props.onClose;
      var _state = this.state;
      var item = _state.item;
      var progress = _state.progress;


      return _react2.default.createElement(
        _components.Modal,
        { onClose: function onClose() {
            return _onClose(item);
          } },
        _react2.default.createElement(
          'div',
          { className: _EditModal2.default.content },
          _react2.default.createElement(
            'div',
            { className: 'grid' },
            _react2.default.createElement(
              'div',
              { className: 'col--1-of-4' },
              _react2.default.createElement(
                'div',
                { className: _EditModal2.default.slider },
                item.images && item.images.length > 0 && _react2.default.createElement(
                  _nukaCarousel2.default,
                  { decorators: _SliderDecorator2.default, afterSlide: function afterSlide(index) {
                      return _this3._handleEdit('activeImg', index);
                    } },
                  item.images.map(function (image, i) {
                    return _react2.default.createElement('div', { key: 'img_' + i, className: _EditModal2.default.slide, style: { backgroundImage: 'url(' + image + ')' } });
                  })
                ),
                item.images && item.images.length === 0 && _react2.default.createElement(
                  _reactDropzone2.default,
                  {
                    disableClick: false,
                    multiple: false,
                    className: (0, _classnames2.default)(_EditModal2.default.slide, _EditModal2.default.dropzone),
                    activeClassName: _EditModal2.default.active,
                    onDrop: this._onDrop },
                  _react2.default.createElement(
                    'div',
                    { className: _EditModal2.default.dropzoneContent },
                    progress === 0 && _react2.default.createElement(
                      'p',
                      null,
                      'Click to add a picture'
                    ),
                    progress > 0 && _react2.default.createElement(
                      'p',
                      { className: _EditModal2.default.progress },
                      progress,
                      '%'
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col--3-of-4' },
              _react2.default.createElement(
                'div',
                { className: _EditModal2.default.details },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Informations'
                ),
                _react2.default.createElement(
                  'div',
                  { className: _EditModal2.default.input },
                  _react2.default.createElement(
                    'label',
                    { className: _EditModal2.default.label },
                    'Product name'
                  ),
                  _react2.default.createElement('input', { type: 'text', value: item.title, onChange: function onChange(e) {
                      return _this3._handleEdit('title', e.target.value);
                    }, className: _EditModal2.default.inputTitle })
                ),
                _react2.default.createElement(
                  'div',
                  { className: _EditModal2.default.input },
                  _react2.default.createElement(
                    'label',
                    { className: _EditModal2.default.label },
                    'description'
                  ),
                  _react2.default.createElement(
                    'textarea',
                    { className: _EditModal2.default.inputDescription, onChange: function onChange(e) {
                        return _this3._handleEdit('description', e.target.value);
                      } },
                    item.description
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: _EditModal2.default.productMeta },
                  _react2.default.createElement(
                    'div',
                    { className: _EditModal2.default.input },
                    _react2.default.createElement(
                      'label',
                      { className: _EditModal2.default.label },
                      'Price'
                    ),
                    _react2.default.createElement('input', { type: 'text', value: item.price, onChange: function onChange(e) {
                        return _this3._handleEdit('price', e.target.value);
                      }, className: _EditModal2.default.inputPrice })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _EditModal2.default.input },
                    _react2.default.createElement(
                      'label',
                      { className: _EditModal2.default.label },
                      'Store'
                    ),
                    _react2.default.createElement('input', { type: 'text', value: item.store_url, onChange: function onChange(e) {
                        return _this3._handleEdit('store_url', e.target.value);
                      }, className: _EditModal2.default.inputStore })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _EditModal2.default.input },
                    _react2.default.createElement(
                      'label',
                      { className: _EditModal2.default.label },
                      'Product link'
                    ),
                    _react2.default.createElement('input', { type: 'text', value: item.link, onChange: function onChange(e) {
                        return _this3._handleEdit('link', e.target.value);
                      }, className: _EditModal2.default.inputLink })
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col--4-of-4' },
              _react2.default.createElement(
                'button',
                { className: _EditModal2.default.buttonSave, onClick: function onClick() {
                    return _onClose(item);
                  } },
                'Save item'
              )
            )
          )
        )
      );
    }
  }]);
  return EditModal;
}(_react.Component);

exports.default = EditModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Item/EditModal/EditModal.js
 ** module id = 1096
 ** module chunks = 0
 **/